/*
 * pv-whatsapp-context.js
 *
 * Keeps every "Chat with us" destination describing what the shopper is looking
 * at right now.
 *
 * snippets/pv-whatsapp-link.liquid already renders a complete, correct link on
 * the server, so the control works with no JavaScript at all and a crawler sees
 * a real address. This file only does the one thing the server cannot: follow a
 * variant the shopper chooses after the page was rendered.
 *
 * It owns no copy. The translated sentence arrives on the element as
 * data-pv-wa-template with [[TITLE]] and [[URL]] where its two values belong,
 * so the Arabic storefront sends the Arabic sentence and the English one the
 * English sentence without this file knowing either exists.
 *
 * The address never comes from location.href: it is the canonical URL Liquid
 * put on the element, which carries no query string, so no ?variant=, no
 * preview_theme_id and no tracking parameter can reach a customer's message.
 *
 * TWO WAYS A VARIANT CAN CHANGE, BECAUSE THIS THEME HAS TWO
 *
 * assets/global.js dispatches `variant:change` with the variant object, which
 * is the cleanest signal and is used where it exists. The Cove product page
 * does not go through it: `cove-product-r18-v6` handles its own option inputs
 * in onOptionInputChange and never dispatches the event, so a colour chosen
 * there would have left the message on the opening variant. So the form itself
 * is watched as well.
 *
 * NOTHING UNCERTAIN IS SENT
 *
 * Option values are read only when the theme has actually resolved a variant -
 * the form's [name="id"] input holds an id and is enabled - and only when every
 * option group has a value chosen. A half-made selection, or one that matches
 * no variant, leaves the message naming the product alone rather than
 * describing a combination the shopper is not looking at.
 *
 * The values themselves are the radio/select VALUES, which are Shopify's own
 * option values in the storefront's language - the same strings that make up
 * variant.title. The message is read by a person, so it has to be in their
 * language; the variant itself is never identified from them.
 */
(function () {
  'use strict';

  if (window.PvWhatsAppContext) return;

  var SELECTOR = 'a[data-pv-wa="product"]';

  function encode(text) {
    return encodeURIComponent(text).replace(/'/g, '%27');
  }

  /* The chosen option values, in option order, or '' when the selection is not
     complete and resolved. */
  function labelFromForm(form) {
    if (!form) return '';

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || idInput.disabled || !idInput.value) return '';

    var groups = form.querySelectorAll('fieldset');
    var values = [];
    for (var i = 0; i < groups.length; i++) {
      var checked = groups[i].querySelector('input[type="radio"]:checked');
      var select = groups[i].querySelector('select');
      if (checked) values.push(checked.value);
      else if (select && select.value) values.push(select.value);
      else if (groups[i].querySelector('input[type="radio"], select')) return '';
    }

    if (!values.length) return '';
    var title = values.join(' / ').trim();
    return title === 'Default Title' ? '' : title;
  }

  function labelFromVariant(variant) {
    if (!variant) return '';
    var title = typeof variant.title === 'string' ? variant.title.trim() : '';
    return !title || title === 'Default Title' ? '' : title;
  }

  function apply(link, label) {
    var phone = link.getAttribute('data-pv-wa-phone') || '';
    var template = link.getAttribute('data-pv-wa-template') || '';
    var title = link.getAttribute('data-pv-wa-title') || '';
    var url = link.getAttribute('data-pv-wa-url') || '';
    if (!phone || !template) return;

    var subject = label ? title + ' (' + label + ')' : title;
    var message = template.split('[[TITLE]]').join(subject).split('[[URL]]').join(url);

    link.setAttribute('href', 'https://wa.me/' + phone + '?text=' + encode(message));
  }

  function update(label) {
    var links = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < links.length; i++) apply(links[i], label);
  }

  function form() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function refreshFromForm() {
    update(labelFromForm(form()));
  }

  /* assets/global.js hands us the variant object itself, so nothing has to be
     read from the page when this path is the one that fires. */
  document.addEventListener('variant:change', function (event) {
    var variant = event && event.detail ? event.detail.variant : null;
    if (!variant) return;
    update(labelFromVariant(variant));
  });

  /* The Cove product page's own path. Delegated on the document so it survives
     a section re-render in the theme editor, and read on the next frame because
     the theme resolves [name="id"] in a requestAnimationFrame of its own. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;
    if (!target.matches('input[type="radio"], select')) return;
    if (!target.closest('form[action*="/cart/add"]')) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(refreshFromForm);
    });
  });

  /* An address that already names a variant is rendered correctly by Liquid, so
     this only catches a page whose form resolved a different opening variant
     client-side. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFromForm);
  } else {
    refreshFromForm();
  }

  window.PvWhatsAppContext = { update: update, refresh: refreshFromForm };
})();
